import { render } from "./indoor-equipment.vue?vue&type=template&id=2ef89927"
const script = {}

import "./indoor-equipment.vue?vue&type=style&index=0&id=2ef89927&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__